"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var MasterData = function MasterData(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "21.818",
    height: "24",
    viewBox: "0 0 21.818 24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-1033 -3601)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1043.909,3601c-6.117,0-10.909,1.977-10.909,4.5,0,1.585,4.867,3.5,10.909,3.5,5,0,9.409-1.262,10.909-2.578v-.922C1054.818,3602.977,1050.026,3601,1043.909,3601Z",
    transform: "translate(0)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1033,3607.362V3610c0,1.585,4.865,3.5,10.909,3.5,4.994,0,9.409-1.262,10.909-2.579v-3.252c-2.33,1.436-6.782,2.331-10.909,2.331C1039.584,3610,1035.031,3608.992,1033,3607.362Z",
    transform: "translate(0 0.802)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1033,3611.862v2.638c0,1.585,4.865,3.5,10.909,3.5,4.994,0,9.409-1.262,10.909-2.578v-3.253c-2.331,1.436-6.783,2.331-10.909,2.331C1039.584,3614.5,1035.031,3613.492,1033,3611.862Z",
    transform: "translate(0 1.37)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1033,3616.362v2.138c0,2.523,4.792,4.5,10.909,4.5s10.909-1.977,10.909-4.5v-1.831c-2.331,1.436-6.783,2.331-10.909,2.331C1039.584,3619,1035.031,3617.992,1033,3616.362Z",
    transform: "translate(0 2)"
  })));
};

MasterData.propTypes = {};
MasterData.defaultProps = {};
var _default = MasterData;
exports["default"] = _default;